module.exports = "https://cwa.roocdn.com/_next/static/apple-touch-icon.e55c2aa6.png";